module.exports = __webpack_public_path__ + "static/img/btn.5cd74d71.png";